import { styled } from '@linaria/react';

function RedContrast() {
  return (
    <Wrapper>
      <Control aria-label="A vibrant red square" />

      <Experiment aria-label="An even-more-vibrant red square" />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 4px;
  margin-top: 16px;
  margin-bottom: 48px;
`;

const Cell = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 4px;
  overflow: hidden; /* trim corners */
`;

const Control = styled(Cell)`
  background: rgb(255 0 0);
`;

const Experiment = styled(Cell)`
  background: color(display-p3 1 0 0);
`;

export default RedContrast;
